const BrandLogo = ({ className = "", variant = "wordmark" }) => {
  if (variant === "mark") {
    return (
      <span className={`inline-flex h-10 w-10 shrink-0 overflow-hidden rounded-xl bg-[#39217b] shadow-sm ${className}`}>
        <img
          src="/50cr_club_logo_purple_light.png"
          alt="50 CR CLUB"
          className="h-full w-full object-cover"
          data-testid="brand-mark"
        />
      </span>
    );
  }

  return (
    <img
      src="/50cr_club_logo_purple_light%20(1).png"
      alt="50 CR CLUB"
      className={`h-[1.8em] w-auto max-w-full object-contain align-middle mix-blend-multiply ${className}`}
      data-testid="brand-wordmark"
    />
  );
};

export default BrandLogo;
